<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline">You are viewing experiments in group: <span
                        class="text--secondary">{{ $route.params.name }}</span></div>
            </v-col>
        </v-row>

        <Experiment
                v-for="(entry, index) in entries"
                v-bind:key="entry.data.uuid"
                v-bind:index="index"
                v-bind:response-data="entry"
        />

    </v-container>
</template>

<script>
    import ExperimentsAPI from '@/services/api/ABTesting/Experiments'
    import Experiment from '@/components/Experiment';

    export default {
        name: 'GroupDetails',
        methods: {
            addExperiment() {
                this.$router.redirect
            }
        },
        components: {
            Experiment,
        },
        data () {
            return {
                entries: []
            }
        },
        created() {
            ExperimentsAPI.getExperiments(this.$route.params.name, 7)
                .then(response => {
                    this.entries = response.collection
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
</script>

<style scoped>

</style>
